export const formatExpiryDate = (value) => {
  if (!value || typeof value !== 'string' || value.length < 3 || value[2] === '/') {
    return value;
  }
  return [value.slice(0, 2), '/', value.slice(2)].join('');
};
